/* eslint-disable react/jsx-props-no-spreading */
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { objectUtils } from '../../../utils';
import useStyles from './useStyles';

const InputAutoComplete = ({
  _id,
  label,
  name,
  value,
  onChange,
  required,
  options,
  disabled,
  defaultValue,
  freeSolo,
  error,
  helperText,
  placeholder,
  ...props
}) => {
  const classes = useStyles();

  const [mValue, setValue] = useState(value || defaultValue || null);

  useEffect(() => {
    if (mValue !== value) {
      setValue(value);
    }
  }, [value]);

  const handleChange = (event, newValue) => {
    const newVal = objectUtils.isObjectWithKeys(newValue, ['name']) ? newValue.name : event?.target?.value;
    setValue(newVal);
    if (onChange) {
      onChange(event, newVal);
    }
  };

  return (
    <Autocomplete
      id={_id}
      freeSolo={freeSolo}
      options={options}
      value={mValue}
      onChange={handleChange}
      disabled={disabled}
      getOptionLabel={(option) => {
        if (typeof option === 'string') return option;
        return option?.label || option?.name || '';
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          margin="normal"
          variant="filled"
          className={classes.input}
          required={required}
          error={error}
          helperText={helperText}
          placeholder={placeholder}
          onChange={handleChange}
          InputLabelProps={{
            classes: {
              root: classes.inputLabelRoot,
              focused: classes.InputLabelPropsFocused,
            },
          }}
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            classes: {
              root: classes.inputRoot,
              focused: classes.InputPropsFocused,
              input: classes.InputPropsInput,
            },
          }}
          fullWidth
        />
      )}
      {...props}
    />
  );
};

InputAutoComplete.propTypes = {
  _id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
  })),
  disabled: PropTypes.bool,
  defaultValue: PropTypes.string,
  freeSolo: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

InputAutoComplete.defaultProps = {
  _id: '',
  label: '',
  name: '',
  value: '',
  onChange: () => {},
  required: false,
  options: [],
  disabled: false,
  defaultValue: '',
  freeSolo: false,
  error: false,
  helperText: '',
  placeholder: '',
  className: '',
};

export default InputAutoComplete;
